var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "project-images-galerys",
      attrs: { id: "pb-gallery-" + _vm.galleryNumber }
    },
    [
      _vm.data.width > 959 || true
        ? _c("project-gallery-destop", {
            attrs: {
              images: _vm.images,
              visible: true,
              "is-mobile": _vm.data.width <= 959,
              "gallery-number": _vm.galleryNumber
            },
            on: { showModalGallery: _vm.onShowModalGallery }
          })
        : _vm._e(),
      _vm.data.width <= 959 && false
        ? _c("mobile-gallery", {
            attrs: {
              images: _vm.images,
              visible: true,
              "gallery-number": _vm.galleryNumber
            },
            on: { showModalGallery: _vm.onShowModalGallery }
          })
        : _vm._e(),
      _c("modal-gallery", {
        attrs: {
          images: _vm.images,
          visible: _vm.data.visible,
          index: _vm.data.index,
          "is-mobile": _vm.data.width <= 959,
          "gallery-number": _vm.galleryNumber,
          "use-thumbnails": _vm.useThumbnails
        },
        on: { settingVisible: _vm.onSettingVisible }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }